/**
 * dashboard/classes/$classId.tsx — Class detail surface.
 *
 * Lives at `/dashboard/classes/$classId`. Auth-gated to approved tutors;
 * the same shape as `/dashboard/classes/*` so we can reuse ClassDetail.
 */

import { createFileRoute, redirect } from '@tanstack/react-router';
import { ClassDetail } from '../../../components/tutor/ClassDetail.js';
import { freshSessionQuery, type SessionPrincipal } from '../../../lib/api/queries.js';

export const Route = createFileRoute('/dashboard/classes/$classId')({
  beforeLoad: async ({ context, location }) => {
    const session = await context.queryClient.fetchQuery(freshSessionQuery);
    const user = session?.ok ? (session.data?.user ?? null) : null;
    if (!user) {
      throw redirect({
        to: '/login',
        search: { error: undefined, redirect: location.href },
      });
    }
    if (user.role === 'admin') {
      throw redirect({ to: '/admin' });
    }
    if (user.role !== 'tutor' || !user.isApprovedTutor) {
      throw redirect({ to: '/me' });
    }
    return null;
  },
  component: ClassDetailRoute,
});

function ClassDetailRoute() {
  const { classId } = Route.useParams();
  return <ClassDetail classId={classId} />;
}
